import { ref, onMounted, onBeforeUnmount } from "vue";
import { useTranslationStore } from "@/stores/translations";
import { useRuntimeConfig, useFetch, useNuxtApp } from "#app";

export const useEmailAlertsUnsubscribe = () => {
  const nuxtApp = useNuxtApp();

  const translationStore = useTranslationStore();
  const translate = translationStore.translate;

  const isLoading = ref(false);
  const LoadingTitle = ref(translate("loading"));
  const formSuccess = ref(false);
  const formTitle = ref(translate("email.alerts.unsubscribe.form"));
  const formMessage = ref(null);
  const showModal = ref(false);  

  const submitForm = async (event) => {
    try {
      const token = await nuxtApp.$recaptcha.execute("subscribe");
      const form = event.target;
      const formData = new FormData(form);

      formData.append("recaptchaToken", token);

      const baseApi = useRuntimeConfig().public.baseApi;

      isLoading.value = true;
      LoadingTitle.value = translate("sending");
      formSuccess.value = false;

      await useFetch(`${baseApi}/mail/email-alerts-unsubscribe`, {
        method: "POST",
        headers: {
          "X-CSRF-TOKEN": "NUXT",
        },
        body: formData,
      }).then(
        (res) => {
          const data = res.data.value;

          if (data && data.status == "success") {
            formSuccess.value = true;
            formMessage.value = data.data;
            form.reset();
          } else {
            formSuccess.value = false;
            formMessage.value = data.data;
          }
        },
        (error) => {
          formSuccess.value = false;
          formMessage.value = "error usefetch:" + error;
        }
      );
    } catch (error) {
      formMessage.value = "error catch:" + error;
      formSuccess.value = false;
    }

    showModal.value = true;
    isLoading.value = false;
  };

  const resetModal = () => {
    showModal.value = false; // รีเซ็ตค่า showModal เมื่อ Modal ถูกปิด
  };

  onMounted(() => {
    nuxtApp.$recaptcha.init();
    nuxtApp.$recaptcha.hideBadge = false;

    // Fetch translations
    //translationStore.fetchTranslations();
  });

  onBeforeUnmount(() => {
    nuxtApp.$recaptcha.destroy();
  });

  return {
    isLoading,
    LoadingTitle,
    formSuccess,
    formTitle,
    formMessage,
    showModal,
    translate,
    submitForm,
    resetModal,
  };
};
